import { ErrorMessage } from '@hookform/error-message';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { RHFPercentField } from '@openx/components-core/lib/NumberField/RHFPercentField.tsx';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import { type Path, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CuratedDealBuyerDiscountsFormData } from '../types.ts';

export const DiscountDetailsSection = () => {
  const {
    formState: { errors },
    trigger,
  } = useFormContext<CuratedDealBuyerDiscountsFormData>();

  const { t } = useTranslation();

  const onDiscountChanged = () => {
    trigger('min_one_discount_error');
  };

  return (
    <FormSection divider rightColumnSize={RIGHT_COLUMN_WIDTH} title={t('Discount Details')}>
      <RHFTextField<CuratedDealBuyerDiscountsFormData>
        dataTest="discount-name"
        fullWidth
        label={t('Discount Name')}
        margin="dense"
        name={'name' satisfies Path<CuratedDealBuyerDiscountsFormData>}
        placeholder={t('Enter Discount Name')}
      />
      <Typography
        gutterBottom
        variant="h3"
        sx={{
          mt: 3,
        }}
      >
        {t('Discount Settings')}
      </Typography>

      <RHFPercentField<CuratedDealBuyerDiscountsFormData>
        dataTest="banner-and-video-discount"
        error={!!errors.min_one_discount_error || !!errors.banner_and_video_discount}
        label={t('Banner and Video Discount')}
        name={'banner_and_video_discount'}
        onChangeComplete={onDiscountChanged}
      />

      <RHFPercentField<CuratedDealBuyerDiscountsFormData>
        dataTest="ctv-discount"
        error={!!errors.min_one_discount_error || !!errors.ctv_discount}
        label={t('CTV Discount')}
        name={'ctv_discount' satisfies Path<CuratedDealBuyerDiscountsFormData>}
        onChangeComplete={onDiscountChanged}
      />

      <ErrorMessage
        errors={errors}
        name={'min_one_discount_error' satisfies Path<CuratedDealBuyerDiscountsFormData>}
        render={({ message }) => (
          <FormHelperText error margin="dense" sx={{ ml: 0, mt: 2.5 }}>
            {message}
          </FormHelperText>
        )}
      />
    </FormSection>
  );
};
